




    function toggleDropdown(element) {
        let $dropdown = $(element).next();
        $dropdown.toggle();
    }

    function selectItem(element) {
        let $parent = $(element).closest('.products-addon');
        let $selectedItem = $parent.find('.selected-item');
        let $hiddenInput = $parent.find(".selected-value");

        // Get selected product details
        let newImage = $(element).find("img").attr("src");
        let newTitle = $(element).find(".item-title").text();
        let newHandle = $(element).find(".hidden-radio").val();
        let var_id = $(element).find(".hidden-radio").data('var-id');


      
        // Update selected product
        $selectedItem.find("img").attr("src", newImage);
        $selectedItem.find(".selected-title").text(newTitle);
        $selectedItem.find(".hidden-radio").val(newHandle);




        // Update hidden input value
        $hiddenInput.val(newHandle);
        $hiddenInput.attr('data-product-id', var_id);


      
        // Hide dropdown
        $(element).parent().hide();

        // Refresh dropdown: hide selected item and show others
        $parent.find(".item-data").each(function () {
            $(this).toggle($(this).attr("data-handle") !== newHandle);
        });
    }

    // Attach event handlers
    $(document).on("click", ".dropdown-toggle", function () {
        toggleDropdown(this);
    });

    $(document).on("click", ".item-data", function () {
        selectItem(this);
    });


  function initializeComplimentorySlider() {
   var $swiperSelector = $('.comp-slider');

   $swiperSelector.each(function(index) {
     var $this = $(this);
     $this.addClass('swiper-slider-' + index);

     var dragSize = $this.data('drag-size') ? $this.data('drag-size') : 100;
     var freeMode = $this.data('free-mode') ? $this.data('free-mode') : true;
     var loop = $this.data('loop') ? $this.data('loop') : false;
     var slidesDesktop = $this.data('slides-desktop') ? $this.data('slides-desktop') : 4;
     var slidesTablet = $this.data('slides-tablet') ? $this.data('slides-tablet') : 3;
     var slidesMobile = $this.data('slides-mobile') ? $this.data('slides-mobile') : 1.5;
     var spaceBetween = $this.data('space-between') ? $this.data('space-between') : 20;

     // Initialize Swiper
     var swiper = new Swiper('.swiper-slider-' + index, {
       direction: 'horizontal',
       loop: loop,
       freeMode: freeMode, // Enables smooth scrolling
       spaceBetween: 12,
       slidesPerView: 2.1,
            breakpoints: {     
        480: {
          slidesPerView: 1.5,
        },
        767: {
          slidesPerView: 3,
        },
        991: {
          slidesPerView: 1.5,
        },
        1180: {
          slidesPerView: 2,
        },
        1366: {
          slidesPerView: 2.1,
        },
        1440: {
          slidesPerView: 3.2,
        },
      },
       navigation: {
         nextEl: '.swiper-button-next-related',
         prevEl: '.swiper-button-prev-related'
       },




       // If we need pagination
       pagination: {
         el: ".swiper-pagination",
         dynamicBullets: true,
         clickable: true
       },
       scrollbar: {
         el: '.swiper-scrollbar',
         draggable: true,
         dragSize: dragSize,
         snapOnRelease: false // Prevent snapping to the nearest slide
       }
     });
   });


   }


     initializeComplimentorySlider();


// function initializeComplimentorySlider(containerSelector) {
//   // Check if Swiper is already initialized
//   if (document.querySelector(containerSelector)) {
//     const container = document.querySelector(containerSelector);

//     // Destroy existing Swiper instance if it exists
//     if (container.swiper) {
//       container.swiper.destroy(true, true);
//     }

//     // Initialize Swiper
//     const swiper = new Swiper(containerSelector, {
//       slidesPerView: 3, // Adjust based on layout
//       spaceBetween: 20, // Spacing between slides
//       loop: false, // Infinite loop scrolling
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       },
//       pagination: {
//         el: '.swiper-pagination',
//         clickable: true,
//       },
//       breakpoints: {
//         1024: {
//           slidesPerView: 4,
//         },
//         768: {
//           slidesPerView: 3,
//         },
//         480: {
//           slidesPerView: 1.5,
//         },
//       },
//     });

//     console.log('Swiper initialized:', swiper);
//     return swiper; // Return the Swiper instance if needed
//   }
// }




//   document.addEventListener('DOMContentLoaded', function () {
//     initializeComplimentorySlider(); // Initial call

//     // Reinitialize on window resize (if layout changes)
//     window.addEventListener('resize', function () {
//       initializeComplimentorySlider();
//     });
//   });



// $(document).on("click", ".cs-price-buy", function (event) {




  

//     let var_ids = $('.selected-value').map(function () {
//         return $(this).data('product-id');
//     }).get(); // Get all product IDs as an array

//     var productData = var_ids.map(function(variantId) { // Use var_ids instead of productIds
//         return { 
//             quantity: 1, 
//             id: variantId,
//             properties: { 
//                     bundle: 'bundle' 
//                 } 
//         };
//     });

//     var data = {
//         items: productData
//     };

//     console.log(data);

//     // Uncomment to enable AJAX request to add products to cart

//     $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: JSON.stringify(data),
//         contentType: 'application/json',
//         dataType: 'json',
//         success: function(cart) {
          
//                $("cart-drawer").removeClass("is-empty");
//                      $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');

//                      $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *');
//                     $("cart-drawer").addClass("active");
//                      $("body.gradient").addClass("overflow-hidden");


          
//         },
//         error: function(error) {
//             console.error('Error adding products to cart:', error);
//         }
//     });
//   setTimeout(function(){
//       if (!$(event.target).is(".product-form__submit")) {
//         $(".product-form__submit").trigger("click");
//     }
// },1000);

// });






  // Hide initially selected item from dropdown on page load
  // document.addEventListener("DOMContentLoaded", function() {
  //   document.querySelectorAll(".products-addon").forEach(addon => {
  //     let selectedHandle = addon.querySelector(".selected-value").value;
  //     let allItems = addon.querySelectorAll(".item-data");
      
  //     allItems.forEach(item => {
  //       if (item.getAttribute("data-handle") === selectedHandle) {
  //         item.style.display = "none";
  //       }
  //     });
  //   });
  // });


// complimentory slider




// jQuery(document).ready(function($) {

//   new Swiper(".comp-slider", {
//     loop: false,
//     pagination: { el: ".swiper-pagination", clickable: true },
//     spaceBetween: 20,

//    breakpoints: {
//         320: { slidesPerView: "1" }, // Mobile
//         768: { slidesPerView: "1" }, // iPad
//         1024: { slidesPerView: "2" }, // Laptop
//         1600: { slidesPerView: "3" }, // Large screens
//       },
//      scrollbar: {
//          el: '.swiper-scrollbar',
//          draggable: true,
//          dragSize: 100,
//          snapOnRelease: false // Prevent snapping to the nearest slide
//        }

    
//   });

//   });


  // jQuery(document).ready(function($) {
  //     function initSlickSlider() {
  //         if ($('.comp-slider').length && $('.comp-slider li').length > 0) {
  //               $('.comp-slider').slick({
  //                   dots: true,
  //                   infinite: true,
  //                   speed: 1000,
  //                   slidesToShow: 3.2,
  //                   slidesToScroll: 1,
  //                   autoplay: false,
  //                   autoplaySpeed: 2000,
  //                   arrows: true,
  //                   responsive: [{
  //                       breakpoint: 1400,
  //                       settings: {
  //                           dots: false,
  //                           arrows: false,
  //                           slidesToShow: 2,
  //                           slidesToScroll: 1
  //                       }
  //                   },
  //                   {
  //                       breakpoint: 600,
  //                       settings: {
  //                           dots: false,
  //                           arrows: false,
  //                           slidesToShow: 2,
  //                           slidesToScroll: 1
  //                       }
  //                   }]
  //               });
  //         } else {
  //             setTimeout(initSlickSlider, 500); // Retry if not yet loaded
  //         }
  //     }

  //     // Run only after Shopify recommendations are loaded
  //     $(document).on('shopify:section:load', function() {
  //         initSlickSlider();
  //     });

  //     initSlickSlider(); // Initial attempt







  //       // $(".cs-price-buy").click(function(event){
  //       //     if (!$(event.target).is(".product-form__submit")) {
  //       //         $(".product-form__submit").trigger("click");
  //       //     }
  //       // });









    
  // });





          



